import type { StatusChipProps } from '@components/v2/ui/StatusChip/StatusChip';
import { RefreshCcw } from 'lucide-react';
import { SyncResultStatusEnum } from '../../../components/Integrations/integrations.types';
import LangEnum from '../../../lang/LangEnum';

export const INTEGRATION_STATUS_CHIP_CONFIG: Record<
  SyncResultStatusEnum,
  Omit<StatusChipProps, 'size'>
> = {
  [SyncResultStatusEnum.ERROR]: {
    label: LangEnum.GLOBAL_INTEGRATE_ERROR,
    icon: RefreshCcw,
    color: 'error',
  },
  [SyncResultStatusEnum.STOCK_VALIDATED]: {
    label: LangEnum.GLOBAL_VALIDATED,
    icon: RefreshCcw,
    color: 'progress',
  },
  [SyncResultStatusEnum.OK]: { label: LangEnum.GLOBAL_SUCCESS, icon: RefreshCcw, color: 'success' },
  [SyncResultStatusEnum.OK_RESET]: {
    label: LangEnum.GLOBAL_SUCCESS,
    icon: RefreshCcw,
    color: 'success',
  },
  [SyncResultStatusEnum.SENDING]: {
    label: LangEnum.GLOBAL_SENT,
    icon: RefreshCcw,
    color: 'progress',
  },
  [SyncResultStatusEnum.SUCCESS_WITH_PAYMENT_ERROR]: {
    label: LangEnum.ORDER_SYNC_STATUS_SUCCESS_WITH_PAYMENT_ERROR,
    icon: RefreshCcw,
    color: 'waiting',
  },
};
